export default {
  label: '高级工程师',
  id: '0',
  children: [
    {
      label: '岗位定义',
      id: '0-1',
      children: [
        {
          label: '通常负责技术战略规划和团队管理',
          id: '0-1-1',
        },
      ],
    },
    {
      label: '岗位职责',
      id: '0-2',
      children: [
        {
          label: '负责公司技术战略规划和团队管理',
          id: '0-2-1',
        },
        {
          label: '指导和领导初级和中级工程师完成复杂项目',
          id: '0-2-2',
        },
        {
          label: '进行技术创新和研发',
          id: '0-2-3',
        },
        {
          label: '制定工艺方案和技术标准',
          id: '0-2-4',
        }
      ]
    },

    {
      label: '技能要求',
      id: '0-3',
      children: [
        {
          label: '具备深厚的专业知识和丰富的行业经验',
          id: '0-3-1',
        },
        {
          label: '具备较强的创新能力和技术领导力',
          id: '0-3-2',
        },
        {
          label: '熟悉现代设计方法和计算机辅助设计技术',
          id: '0-3-3',
        },
        {
          label: '具备较强的组织协调能力和决策能力',
          id: '0-3-4',
        }
      ]
    }
  ]
}